var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#5DC983"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4625 24.75C20.85 24.75 19.2782 24.3938 17.7473 23.6813C16.2162 22.9688 14.86 22.0188 13.6785 20.8312C12.497 19.6437 11.547 18.2842 10.8285 16.7527C10.11 15.2212 9.7505 13.6495 9.75 12.0375V11.6438C9.75 11.5063 9.7625 11.375 9.7875 11.25H14.175L14.8687 15.0187L12.7312 17.175C13.2562 18.075 13.9158 18.9187 14.7098 19.7062C15.5037 20.4937 16.3755 21.175 17.325 21.75L19.5 19.575L23.25 20.325V24.7125C23.125 24.725 22.9938 24.7345 22.8563 24.741C22.7188 24.7475 22.5875 24.7505 22.4625 24.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallLogo);
export default __webpack_public_path__ + "static/media/callLogo.3c60fc8cc979566441c125d61deb2752.svg";
export { ForwardRef as ReactComponent };